import { formatBadgeDescriptionTemplate } from '~/boggle/lib/badges/formatBadgeDescription'

import { BOGGLE_TIERED_FAMILY_CONFIGS } from './families/tieredFamilies'
import { buildTierBadgeId } from './familyBadgeId'
import { BOGGLE_TIER_ROMAN } from './familyTypes'
import { getBoggleBadgePointsForLevel, type BoggleBadgeDefinition } from './types'

export function expandTieredBadgeFamilies(): BoggleBadgeDefinition[] {
  const definitions: BoggleBadgeDefinition[] = []
  for (const family of BOGGLE_TIERED_FAMILY_CONFIGS) {
    for (const tier of family.tiers) {
      const roman = BOGGLE_TIER_ROMAN[tier.tierIndex - 1] ?? String(tier.tierIndex)
      definitions.push({
        category: family.category,
        description:
          tier.descriptionOverride ??
          formatBadgeDescriptionTemplate(family.descriptionTemplate, tier.tierIndex),
        descriptionTemplate: family.descriptionTemplate,
        familyId: family.familyId,
        iconId: family.iconId,
        id: buildTierBadgeId(family.familyId, tier.tierIndex),
        level: tier.level,
        lockedReveal: family.lockedReveal,
        name: tier.tierIndex === 1 ? family.name : `${family.name} ${roman}`,
        points: getBoggleBadgePointsForLevel(tier.level),
        tierIndex: tier.tierIndex,
      })
    }
  }
  return definitions
}

export const BOGGLE_TIERED_BADGE_DEFINITIONS = expandTieredBadgeFamilies()
